//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { AutoCompleteExtraProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { useCompanyService } from "serviceHooks";
//#endregion
import { FilterHelper, QueryStateHelper } from "utils/helpers";

function useSIEFilesReportFilterDefinition() {
  const companyService = useCompanyService();
  const apiToReportFilterFormatter = async (
    filter: WintSuperkollAPIModel.SIEFileFilter
  ): Promise<DocumentFormTypes.SIEFilter> => {
    const reportFilter: DocumentFormTypes.SIEFilter = {
      fileName: filter.fileName,
      uploadedById: filter.uploadedByIds?.length ? filter.uploadedByIds[0] : undefined,
      uploadedByName: filter.uploadedByIds?.length
        ? await companyService.getEmployeeName(filter.uploadedByIds[0])
        : undefined,
    };

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.Document.SIEFilter.UploadedDate,
      filter.uploadedFrom,
      filter.uploadedTo
    );

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<DocumentFormTypes.SIEFilter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        uploadedByName: {
          label: TranslationKeys.Common.HandledBy,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          placeholder: TranslationKeys.Common.Search,
          extraProps: {
            referenceFieldName: FormFieldConstants.Document.SIEFilter.UploadedById,
            items: (searchStr: string) => companyService.SearchPersonsAutoComplete(searchStr),
          } as AutoCompleteExtraProps<DocumentFormTypes.SIEFilter>,
        },
        uploadedDate: {
          label: TranslationKeys.Common.Date,
          type: FormEnums.FormFieldType.DATERANGE,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<DocumentFormTypes.SIEFilter> = {
    fileName: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Document.SIEFilter.FileName),
    uploadedDate: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Document.SIEFilter.UploadedDate),
    uploadedById: QueryStateHelper.numberQueryEncoder(FormFieldConstants.Document.SIEFilter.UploadedById),
    uploadedByName: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Document.SIEFilter.UploadedByName),
  };

  return { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter };
}

export default useSIEFilesReportFilterDefinition;
